import { builder } from "../builder";

builder.input("QuestionCreateInput", {
  question: builder.string().required(),
});
